// extracted by mini-css-extract-plugin
module.exports = {"notes":"styles_notes__OFPaI","innerPadding":"styles_innerPadding__2lnOk"};